import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { CustomSpinnerComponent } from '../../dxc-custom/custom-spinner/custom-spinner.component';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [CustomSpinnerComponent, TranslateModule],
})
export class LoadingComponent {
  isCustomIDP = environment.ENV_ACTIVE_PROFILE === 'customIDP';
}
